export var TOGGLE_FULL_SCREEN = 'TOGGLE_FULL_SCREEN';
export var toggleFullScreen = function (postId) { return ({
    type: TOGGLE_FULL_SCREEN,
    payload: postId,
}); };
//# sourceMappingURL=fullscreenBlock.js.mapexport var TOGGLE_FULL_SCREEN = 'TOGGLE_FULL_SCREEN';
export var toggleFullScreen = function (postId) { return ({
    type: TOGGLE_FULL_SCREEN,
    payload: postId,
}); };
//# sourceMappingURL=fullscreenBlock.js.map